module.exports = __webpack_public_path__ + "img/mtznzxsxt.fbcf129c.jpg";